import { createContext, useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  loadFiltersFromLocalStorage,
  saveFiltersToLocalStorage,
  removeFiltersFromLocalStorage,
} from "../Components/Common/CommonFunction";
import { fetchCompanyProfile } from "../redux/recruiter/company_profile/actions";

export const CandidateSearchContext = createContext();

export default function CandidateSearchProvider({ children }) {
  const dispatch = useDispatch();

  const companyProfileReducerData = useSelector(
    (state) => state.companyProfileReducer
  );

  const [profileData, setProfileData] = useState(null);
  const [filters, setFilters] = useState(null); // Initialize filters as null
  const [pagePerpage, setPagePerpage] = useState({ page: 1, per_page: 10 });
  const shouldSaveToLocal = useRef(false); // Prevent saving default filters
  console.log("filters44",filters);
  useEffect(() => {
    // Fetch company profile on component mount
    dispatch(fetchCompanyProfile());
  }, [dispatch]);

  useEffect(() => {
    if (
      companyProfileReducerData &&
      !companyProfileReducerData.isLoading &&
      companyProfileReducerData.data
    ) {
      setProfileData(companyProfileReducerData.data);
    }
  }, [companyProfileReducerData]);

  useEffect(() => {
    const localFilters = loadFiltersFromLocalStorage("candidateSearchFilters", null);

    if (localFilters) {
      // If filters exist in local storage, set them
      setFilters(localFilters);
    } else if (profileData) {
      // If no filters in local storage, set filters based on profile data
      const data = {
        freshness: 30, // Default value
        gender: "",
        locations: [],
        keyword: "",
        minctc: "",
        maxctc: "",
        industry_type: profileData.industry_area ? [profileData.industry_area] : [],
        functional_area: profileData.functional_area_type || [],
        skills: [],
        experience: "",
      };
      setFilters(data);
      saveFiltersToLocalStorage("candidateSearchFilters", data);
    } else {
      // Only set in-memory defaults, don't save
      setFilters({
        freshness: 30,
    gender: "",
    locations: [],
    keyword: "",
    minctc: 0,
    maxctc: 1000000,
    industry_type: [],
    functional_area: [],
    skills: [],
    experience: "",
      });
    }
  }, [profileData]);

  // Save filters to localStorage on change
  useEffect(() => {
    if (shouldSaveToLocal.current && filters) { // Only save if filters are not null
     
      saveFiltersToLocalStorage("candidateSearchFilters", filters);
    }
  }, [filters]);

  const updateFilters = (newFilters,resetPage = false) => {
    shouldSaveToLocal.current = true;
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
      // Reset page to 1 if resetPage is true
  if (resetPage) {
    setPagePerpage({ page: 1, per_page: pagePerpage.per_page });
  }
  };

  const clearFilters = () => {
    shouldSaveToLocal.current = true;
    setFilters({
      freshness: 30,
      gender: "",
      locations: [],
      keyword: "",
      minctc: "",
      maxctc: "",
      industry_type: [],
      functional_area: [],
      skills: [],
      experience: "",
    }); // Clear filters by setting to null
    // removeFiltersFromLocalStorage("candidateSearchFilters");
  };

  const updatePagePerpage = (newFilters) => {
    setPagePerpage((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  return (
    <CandidateSearchContext.Provider
      value={{
        filters,
        updateFilters,
        clearFilters,
        updatePagePerpage,
        pagePerpage,
      }}
    >
      {children}
    </CandidateSearchContext.Provider>
  );
}